import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import apiClient from '../../magpiie-client/client';
import type { RootState } from '../store';

/**
 * Fetch all organizations for the current user
 */
export const fetchOrganizations = createAsyncThunk(
  'organizations/fetchOrganizations',
  async (_, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET('/v2/organizations', {});
    if (error) {
      return rejectWithValue(
        (error as any).message || 'Failed to fetch organizations'
      );
    }
    return data || [];
  },
  {
    // Prevent duplicate fetches - don't run if already loading or already fetched
    condition: (_, { getState }) => {
      const { organizations } = getState() as RootState;
      if (
        organizations.isOrganizationLoading ||
        organizations.hasFetchedOrganizations
      ) {
        return false;
      }
      return true;
    },
  }
);

/**
 * Create a new organization
 */
export const createOrganization = createAsyncThunk(
  'organizations/createOrganization',
  async (
    orgData: { name: string; description?: string },
    { rejectWithValue }
  ) => {
    const { data, error } = await apiClient.POST('/v2/organizations', {
      body: orgData,
    });
    if (error) {
      return rejectWithValue(
        (error as any).message || 'Failed to create organization'
      );
    }
    return data;
  }
);

/**
 * Switch active organization and persist to localStorage
 */
export const switchOrganization = createAction<number>(
  'organizations/switchOrganization'
);

/**
 * Reset hasFetchedOrganizations flag to allow re-fetching
 * (e.g., after accepting an invitation)
 */
export const resetOrganizationsFetched = createAction(
  'organizations/resetOrganizationsFetched'
);
